import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Trash2, Plus, Image as ImageIcon } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function GalleryAdmin() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ image: '', order: 0 });

  useEffect(() => { fetchItems(); }, []);

  const fetchItems = async () => {
    try {
      const { data } = await axios.get(`${API}/api/admin/gallery`, { withCredentials: true });
      setItems(data.sort((a, b) => a.order - b.order));
    } catch (err) { toast.error('Veri yüklenemedi'); }
  };

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append('file', file);
    try {
      const { data } = await axios.post(`${API}/api/upload`, formData, { withCredentials: true });
      
      // Auto submit after upload
      await axios.post(`${API}/api/admin/gallery`, { image: data.url, order: items.length + 1 }, { withCredentials: true });
      toast.success('Görsel galeriye eklendi');
      fetchItems();
    } catch (err) { toast.error('Yükleme başarısız'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Emin misiniz?')) return;
    try {
      await axios.delete(`${API}/api/admin/gallery/${id}`, { withCredentials: true });
      toast.success('Silindi');
      fetchItems();
    } catch (err) { toast.error('Silinemedi'); }
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-slate-900">Kayar Galeri (Marquee)</h1>
        <label className="cursor-pointer bg-primary text-white px-4 py-2 rounded-xl flex items-center gap-2 hover:bg-primary/90 text-sm font-medium">
          <ImageIcon className="w-4 h-4" /> Yeni Görsel Ekle
          <input type="file" className="hidden" accept="image/*" onChange={handleUpload} />
        </label>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
        {items.map((item) => (
          <div key={item.id} className="relative group bg-white p-2 rounded-2xl shadow-sm border border-slate-200">
            <img src={item.image.startsWith('http') ? item.image : API + item.image} alt="" className="w-full h-40 object-cover rounded-xl" />
            <button 
              onClick={() => handleDelete(item.id)}
              className="absolute top-4 right-4 bg-red-500 text-white p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity shadow-lg"
            >
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        ))}
        {items.length === 0 && <div className="col-span-full text-center py-12 text-slate-500">Henüz galeriye görsel eklenmemiş.</div>}
      </div>
    </div>
  );
}
